<template>
  <div class="columnBox">
    <van-form ref="ruleFormRef" label-width="120px">
      <van-cell-group>
        <van-field v-model="state.detailObj.task_name" label="任务名称" name="task_name" readonly/>
        <van-field v-model="state.detailObj.parent_task_name" label="父任务" name="parent_task_name" readonly/>
        <van-field v-model="state.detailObj.priority_level_name" label="优先级" readonly/>
        <van-field v-model="state.detailObj.assign_emp_name" label="指派人" name="assign_emp_name" readonly/>
        <van-field v-model="state.detailObj.responsible_emp_name" label="负责人" name="responsible_emp_name" readonly/>
        <van-field v-model="state.detailObj.verification_emp_name" label="验收人" name="responsible_emp_name" readonly/>
        <van-field v-model="state.detailObj.task_category_name" label="专题" readonly/>
        <van-field v-model="state.detailObj.plant_time" label="任务规划" readonly/>
        <van-field v-model="state.detailObj.team_name" label="团队" readonly/>
        <van-field
            v-model="state.detailObj.actual_start_time"
            :readonly="state.detailObj.task_status!=='1'"
            :required="state.detailObj.task_status==='1'"
            :rules="[
                     {
                      validator: (value) => {
                        // 必填校验
                        return !!value;
                      },
                      message:'请选择实际开始时间',
                    },
                    {
                      validator: (value) => {
                        const start = new Date(value)
                        const end = new Date(state.detailObj.actual_end_time)
                        return !(start && end && start > end);
                      },
                      message:'实际开始时间不能晚于实际完成时间',
                    }
                  ]"
            label="实际开始时间"
            name="actual_start_time"
            placeholder="请选择实际开始时间"
            @click="handleActualStartClick"
        />
        <van-field
            v-model="state.detailObj.actual_end_time"
            :readonly="!(state.detailObj.task_status==='2'&&parseInt(state.detailObj.task_percentage)===100)"
            :required="state.detailObj.task_status==='2'&&parseInt(state.detailObj.task_percentage)===100"
            :rules="(state.detailObj.task_status==='2'&&parseInt(state.detailObj.task_percentage)===100)?[
                     {
                      validator: (value) => {
                        // 必填校验
                        return !!value;
                      },
                      message:'请选择实际完成时间',
                    },
                    {
                      validator: (value) => {
                        const start = new Date(state.detailObj.actual_start_time)
                        const end = new Date(value)
                        return !(start && end && start > end);
                      },
                      message:'实际完成时间不能早于实际开始时间',
                    }
                  ]:[]"
            label="实际完成时间"
            name="actual_end_time"
            placeholder="请选择实际完成时间"
            @click="(state.detailObj.task_status==='2'&&parseInt(state.detailObj.task_percentage)===100)?state.showActualEnd = true:''"
        />
        <van-field
            v-model="state.detailObj.actual_duration"
            :readonly="!(state.detailObj.task_status==='2'&&parseInt(state.detailObj.task_percentage)===100)"
            :required="state.detailObj.task_status==='2'&&parseInt(state.detailObj.task_percentage)===100"
            :rules="(state.detailObj.task_status==='2'&&parseInt(state.detailObj.task_percentage)===100)?[
                     {
                      validator: (value) => {
                        // 必填校验
                        return !!value;
                      },
                      message:'请输入实际工时',
                    },
                    {
                      validator: (value) => {
                        // 数字格式校验（最多两位小数）
                        return /^\d+(\.\d{1,2})?$/.test(value);
                      },
                      message:'请输入有效的数字',
                    },
                    {
                      validator: (value) => {
                        // 正数校验
                        return parseFloat(value) > 0
                      },
                        message:'请输入正数',
                    },
                    {
                      validator: (value) => {
                        // 数字范围校验
                        return parseFloat(value) <= 999999.99;
                      },
                        message:'输入的数字超长',
                    }
                   ]:[]"
            label="实际工时"
            name="actual_duration"
            placeholder="请输入实际工时"
            type="digit"
        />
        <van-field
            :readonly="state.detailObj.task_status!=='2'"
            label="进度百分比"
            name="task_percentage"
        >
          <template #input>
            <div class="slider">
              <van-slider v-model="state.detailObj.task_percentage" :readonly="state.detailObj.task_status!=='2'">
                <template #button>
                  <div class="custom-button">{{ state.detailObj.task_percentage }}</div>
                </template>
              </van-slider>
            </div>
          </template>
        </van-field>
        <van-field
            v-model="state.detailObj.tag"
            autosize
            label="标签"
            name="tag"
            placeholder="请输入标签"
            rows="1"
            type="textarea"
        />
        <van-field
            v-model="state.detailObj.remark"
            autosize
            label="备注"
            name="remark"
            placeholder="请输入备注"
            rows="1"
            type="textarea"
        />
        <van-field
            v-model="state.detailObj.task_description"
            autosize
            label="任务说明"
            name="task_description"
            placeholder="请输入任务说明"
            readonly
            rows="3"
            type="textarea"
        />
        <van-field
            v-model="state.detailObj.progress_description"
            :readonly="state.detailObj.task_status !== '2'"
            autosize
            label="进度说明"
            name="progress_description"
            placeholder="请输入进度说明"
            rows="3"
            type="textarea"
        />
        <van-field
            v-model="state.detailObj.complete_description"
            :readonly="state.detailObj.task_status !== '2'"
            autosize
            label="完成说明"
            name="complete_description"
            placeholder="请输入完成说明"
            rows="3"
            type="textarea"
        />
        <van-cell-group title="验收">
          <div v-for="(item, index) in state.empList" :key="index" class="verify-card">
            <!-- 验收人 + 状态 -->
            <div class="verify-header">
              <span class="verify-name">验收人：{{ item.emp_code }}-{{ item.emp_name }}</span>
              <van-tag
                  :type="item.verification_status === 'Y' ? 'success' : 'primary'"
                  size="medium"
              >
                {{ item.verification_status === 'Y' ? '已验收' : '未验收' }}
              </van-tag>
            </div>
            <!-- 描述 -->
            <div class="verify-desc">验收描述：{{ item.verification_description || '-' }}</div>
            <div class="verify-desc">拒绝原因：{{ item.reject_reason || '-' }}</div>
          </div>
        </van-cell-group>
        <van-field
            autosize
            label="附件"
            name="附件"
        >
          <template #input>
            <FileListComp v-if="state.detailObj.task_status!=='2'" :fileList="state.fileList" :isTask="true"/>
            <div v-else class="uploadFile">
              <van-uploader
                  v-model="state.ruleForm.fileLists"
                  :after-read="uploadFile"
                  accept
                  upload-icon="plus"
                  @delete="deleteFile"
              />
            </div>
          </template>
        </van-field>

      </van-cell-group>
    </van-form>
    <div class="bottom-button-bar">
      <van-button v-if="state.detailObj.task_status === '1'&&state.queryParams.isMyTask" type="primary"
                  @click="beginTask(ruleFormRef,'2')">开始
      </van-button>
      <van-button v-if="state.detailObj.task_status === '2'&&state.queryParams.isMyTask" type="primary"
                  @click="finishTask(ruleFormRef,'3')">完成
      </van-button>
      <van-button
          v-if="state.detailObj.task_status !== '4' && state.detailObj.task_status !== '5'&&state.queryParams.isMyAssign"
          type="danger"
          @click="updateTaskStatus(state.detailObj.id, 5)"
      >取消
      </van-button>
      <van-button
          v-if="state.detailObj.task_status === '0' && state.queryParams.isMyAssign"
          type="primary"
          @click="updateTaskStatus(state.detailObj.id, 1)"
      >指派
      </van-button>
      <van-button
          v-if="state.detailObj.task_status === '3'&&state.queryParams.isVerifying&&state.queryParams.verificationStatus==='N'"
          type="danger"
          @click="openReturnDialog"
      >退回
      </van-button>
      <van-button
          v-if="state.detailObj.task_status === '3'&&state.queryParams.isVerifying&&state.queryParams.verificationStatus==='N'"
          type="primary"
          @click="openVerifyDialog"
      >验收
      </van-button>
      <van-button
          v-if="state.detailObj.task_status === '5'&&state.queryParams.isMyAssign"
          type="primary"
          @click="updateTaskStatus(state.detailObj.id, 1)"
      >激活
      </van-button>
      <van-button
          v-if="state.queryParams.isMyAssign&&state.detailObj.task_status !== '4'"
          type="primary"
          @click="openEdit(state.detailObj.id)"
      >修改
      </van-button>
      <van-button
          v-if="(state.detailObj.task_status === '0'||state.detailObj.task_status === '1'||state.detailObj.task_status === '2')"
          plain type="primary" @click="handleAssign(state.detailObj.id,state.detailObj.task_name)">拆分
      </van-button>
    </div>
  </div>
  <van-popup
      v-model:show="state.showActualStart" position="bottom">
    <van-datetime-picker
        v-model="state.tempStartTime"
        :min-date="state.currentDate"
        title="实际开始时间"
        type="date"
        @cancel="state.showActualStart = false"
        @confirm="onConfirmActualStart"
    />
  </van-popup>
  <van-popup
      v-model:show="state.showActualEnd" position="bottom">
    <van-datetime-picker
        v-model="state.tempEndTime"
        :min-date="state.currentDate"
        title="实际完成时间"
        type="date"
        @cancel="state.showActualEnd = false"
        @confirm="onConfirmActualEnd"
    />
  </van-popup>
  <van-dialog
      v-model:show="state.verifyDialogVisible"
      show-cancel-button
      title="请输入验收描述"
      @confirm="submitVerify"
  >
    <van-field
        v-model="state.verifyDescription"
        autosize
        placeholder="请填写验收描述"
        rows="3"
        type="textarea"
    />
  </van-dialog>
  <van-dialog
      v-model:show="state.returnDialogVisible"
      show-cancel-button
      title="请输入拒绝原因"
      @confirm="submitReturn"
  >
    <van-field
        v-model="state.returnDescription"
        autosize
        placeholder="请填写拒绝原因"
        rows="3"
        type="textarea"
    />
  </van-dialog>
</template>
<script setup>
import {onMounted, reactive, ref} from "vue";
import ChangeTitle from "@/utils/changeTitle";
import {GetTaskDataById, GetTeamInfoByCurrentEmpId, UpdateTaskStatus} from "@/api/Tmg/myTask";
import {useRoute, useRouter} from "vue-router";
import {Toast} from "vant";
import moment from "moment";
import axios from "axios";
import {nextTick} from "@vue/runtime-core";
import FileListComp from "@/components/FileListComp.vue";
import {UploadBase64} from "@/api/oaApi";
import {isImage} from "@/utils/utils";
import {DownLoadFiles} from "../../api/oaApi";
import {blobToBase64, getFileType} from "../../utils/utils";

const route = useRoute()
const router = useRouter()
const ruleFormRef = ref()
const state = reactive({
  parent_task_name: "",//父任务
  queryParams: {
    id: "",
    page: 1,
    pageSize: 10,
    isMyTask: false,
    isMyAssign: false,
    isVerifying: false,
    verificationStatus: ""
  },
  ruleForm: {
    fileLists: [],
  },
  fileLists: [],
  detailObj: {}, // 详情对象
  fileList: [], // 文件列表
  teamInfo: [],//团队信息
  showActualStart: false,//实际开始时间弹窗
  showActualEnd: false,//实际完成时间弹窗
  currentDate: new Date(),
  tempStartTime: new Date(),
  tempEndTime: new Date(),
  empList: [],//验收信息
  verifyDialogVisible: false,
  verifyDescription: '',
  returnDialogVisible: false,
  returnDescription: '',
})
//点击验收
const openVerifyDialog = () => {
  state.verifyDescription = '';
  state.verifyDialogVisible = true;
};
//点击退回
const openReturnDialog = () => {
  state.returnDescription = '';
  state.returnDialogVisible = true;
};
const submitVerify = () => {
  let list = {
    task_status: '4',
    id: state.queryParams.id,
    verification_description: state.verifyDescription
  }
  UpdateTaskStatus(list).then((res) => {
    if (res.success) {
      Toast.success(res.msg)
      router.go(-1)
    } else {
      Toast.fail(res.msg)
    }
  })
      .catch((error) => {
        Toast.fail('更新状态异常：' + error)
      });
};
const submitReturn = () => {
  let list = {
    task_status: '2',
    id: state.queryParams.id,
    reject_reason: state.returnDescription
  }
  UpdateTaskStatus(list).then((res) => {
    if (res.success) {
      Toast.success(res.msg)
      router.go(-1)
    } else {
      Toast.fail(res.msg)
    }
  })
      .catch((error) => {
        Toast.fail('更新状态异常：' + error)
      });
};
// 获取任务详情
const getTaskDataById = async () => {
  try {
    await nextTick()
    // 获取团队信息
    const teamRes = await GetTeamInfoByCurrentEmpId()
    state.teamInfo = teamRes.data
    const res = await GetTaskDataById({id: state.queryParams.id})
    state.detailObj = res.data.result[0]
    state.empList = res.data.verificationResult
    state.detailObj.responsible_emp_name = res.data.result[0].responsible_emp_code + '-' + res.data.result[0].responsible_emp_name
    state.detailObj.verification_emp_name = res.data.verificationResult
        .map(item => `${item.emp_code}-${item.emp_name}`)
        .join('、');
    state.detailObj.plant_time = moment(state.detailObj.plan_start_time).format('YYYY-MM-DD') + "  -  " + moment(state.detailObj.plan_end_time).format('YYYY-MM-DD')
    state.detailObj.actual_start_time = state.detailObj.actual_start_time ? moment(state.detailObj.actual_start_time).format('YYYY-MM-DD') : ''
    state.detailObj.actual_end_time = state.detailObj.actual_end_time ? moment(state.detailObj.actual_end_time).format('YYYY-MM-DD') : ''
    let findTeam = state.teamInfo.find(t => t.id === state.detailObj.team_id)
    if (findTeam) {
      state.detailObj.team_name = findTeam.team_name
    } else {
      state.detailObj.team_name = ''
    }
    await getFiles(state.detailObj.attachment_id === null ? '' : state.detailObj.attachment_id)
  } catch (err) {
    Toast.fail('加载失败，请重试')
  } finally {
    state.loading.clear()
  }
}
// 获取附件文件列表
const getFiles = async (data) => {
  // 处理附件
  state.fileList = []
  state.fileLists = []
  const list = data.split(',')
  const fileRes = await axios({
    method: 'POST',
    url: '/oa_portal/oa/portal/Common/GetFilelist',
    headers: {Authorization: localStorage.getItem('Token')},
    data: list,
  })
  const tasks = fileRes.data.data.map(async (item) => {
    const fileItem = {
      id: item.id,
      name: item.file_name,
      size: item.file_size,
      type: item.extension.slice(1),
    };
    state.fileList.push(fileItem);

    // 构造 fileLists 中结构
    const result = {
      file: {
        name: item.file_name,
        id: item.id,
        type: getFileType(item.file_name),
      },
    };
    // 如果是图片，尝试下载 base64 内容
    if (isImage(item.extension.slice(1))) {
      const res = await DownLoadFiles({attachment_id: item.id});
      result.content = await blobToBase64(res);
    }

    return result;
  });
  // 并发执行所有任务
  state.fileLists = await Promise.all(tasks);
  state.ruleForm.fileLists = [...state.fileLists];
}
// 分配子任务
const handleAssign = (id, name) => {
  router.push({name: "AddSubTask", query: {id: id, parent_task_name: name}})
}
//确认实际开始时间
const onConfirmActualStart = (val) => {
  state.detailObj.actual_start_time = moment(val).format('YYYY-MM-DD')
  state.showActualStart = false
}
//确认实际完成时间
const onConfirmActualEnd = (val) => {
  state.detailObj.actual_end_time = moment(val).format('YYYY-MM-DD')
  state.showActualEnd = false
}
//当状态为1时才能输入实际开始时间
const handleActualStartClick = () => {
  if (state.detailObj.task_status === '1') {
    state.showActualStart = true;
  }
};
//上传附件
const uploadFile = (file) => {
  const fileArr = []
  const files = Array.isArray(file) ? file : [file]
  files.forEach((item) => {
    fileArr.push({
      base64: item.content.split(',')[1],
      file_name: item.file.name,
    })
  })

  UploadBase64(fileArr, 'tcs').then((res) => {
    if (res.success) {
      const uploaded = res.data.map((item) => {
        const fileObj = {
          file: {
            name: item.file_name,
            id: item.id,
            type: getFileType(item.file_name),
          },
        }

        // 查找当前上传文件的 base64 用于图片预览
        const matched = files.find(f => f.file.name === item.file_name)
        if (matched && isImage(item.extension.slice(1))) {
          fileObj.content = matched.content
        }

        return fileObj
      })
      state.fileLists = [...state.fileLists, ...uploaded]
      state.ruleForm.fileLists = [...state.fileLists]
    } else {
      Toast.fail(res.msg)
    }
  })

}
// 删除附件时触发
const deleteFile = (file) => {
  state.fileLists = state.fileLists.filter(item => item.file.id !== file.file.id)
}
//开始
const beginTask = (formRule, status) => {
  formRule.validate('actual_start_time').then(() => {
    let list = {
      task_status: status,
      id: state.detailObj.id,
      actual_start_time: state.detailObj.actual_start_time,
      tag: state.detailObj.tag,
      remark: state.detailObj.remark
    }
    UpdateTaskStatus(list).then((res) => {
      if (res.success) {
        Toast.success(res.msg)
        router.go(-1)
      } else {
        Toast.fail(res.msg)
      }
    })
        .catch((error) => {
          Toast.fail('更新状态异常：' + error)
        });
  })
}
//完成
const finishTask = (formRule, status) => {
  formRule.validate(['actual_end_time', 'actual_duration', 'task_percentage']).then(() => {
    //上传附件
    let fileIds = []
    if (state.fileLists.length > 0) {
      fileIds = state.fileLists.map(item => item.file.id)
    }
    let list = {
      task_status: status,
      id: state.detailObj.id,
      actual_end_time: state.detailObj.actual_end_time,
      actual_duration: state.detailObj.actual_duration,
      task_percentage: parseInt(state.detailObj.task_percentage),
      progress_description: state.detailObj.progress_description,
      complete_description: state.detailObj.complete_description,
      attachment_id: fileIds.join(), //附件id
      tag: state.detailObj.tag, //标签
      remark: state.detailObj.remark
    }
    UpdateTaskStatus(list).then((res) => {
      if (res.success) {
        Toast.success(res.msg)
        router.go(-1)
      } else {
        Toast.fail(res.msg)
      }
    })
        .catch((error) => {
          Toast.fail('更新状态异常：' + error)
        });
  })
}
//更新任务状态
const updateTaskStatus = (data, type) => {
  let list = {
    task_status: type,
    id: data,
  }
  UpdateTaskStatus(list).then((res) => {
    if (res.success) {
      Toast.success(res.msg)
      router.go(-1)
    } else {
      Toast.fail(res.msg)
    }
  })
      .catch((error) => {
        Toast.fail('更新状态异常：' + error)
      });
};
//点击修改
const openEdit = (id, name) => {
  router.push({name: 'Edit', query: {id: id}})
}
onMounted(() => {
  state.loading = Toast.loading({
    message: '加载中...',
    forbidClick: true,
    duration: 0
  });
  const {id, isAssign, isTask, isVerifying, verificationStatus} = route.query
  if (isTask === "true") {
    state.queryParams.isMyTask = true
  }
  if (isAssign === "true") {
    state.queryParams.isMyAssign = true
  }
  if (isVerifying === "true") {
    state.queryParams.isVerifying = true
    state.queryParams.verificationStatus = verificationStatus
  }
  state.queryParams.id = id
  ChangeTitle.setTitle("任务详情")
  getTaskDataById()
})
</script>
<style lang="scss" scoped>
:deep(.van-cell) {
  flex-direction: column;
}

.headerBox {
  background: #fff;
  padding: 10px 15px;

  p {
    margin: 5px 0;
  }
}

.contentBox {
  padding-bottom: 55px;
}

.columnBox {
  margin: 5px;
  border-radius: 8px;
  overflow: hidden;
  padding-bottom: 60px;
}

.slider {
  width: 100%;
  padding: 0 10px;
}

.custom-button {
  width: 26px;
  color: #fff !important;
  font-size: 10px;
  line-height: 18px;
  text-align: center;
  background-color: var(--van-primary-color);
  border-radius: 100px;
  -webkit-text-fill-color: #fff;
}

/* 底部按钮区域样式 */
.bottom-button-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 12px 16px;
  background-color: #fff;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.05);
  display: flex;
  gap: 10px;
  z-index: 999;
  border-top: 1px solid #f2f2f2;
}

.bottom-button-bar .van-button {
  flex: 1;
  border-radius: 8px;
}

.verify-card {
  background-color: #fff;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 10px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.verify-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
  font-size: 12px;
}

.verify-name {
  color: #333;
}

.verify-desc {
  font-size: 12px;
  color: #666;
  line-height: 1.4;
}

</style>